import { isEqual } from "./ObjectHelper";

export const areEqual = (arr1, arr2): boolean => {
    if (arr1.length !== arr2.length) return false;
    return arr1.every((item, index) => isEqual(item, arr2[index]));
};
